import type { ReactNode } from "react";

import { formatPercent } from "../domain/format.ts";

/**
 * El semicirculo de la plantilla (`gaugeHTML`), en SVG escrito a mano igual que
 * `EquityCurve` (SPEC 3: nada de librerias de graficos en `web/`).
 *
 * Es un arco de 180 grados recortado con `stroke-dasharray`: el largo pintado es
 * la fraccion del arco completo. No lleva marcas ni escala porque la unica
 * lectura es "cuanto de lo posible", y la cifra va debajo en grande.
 *
 * El color se recibe: aqui no se decide si un numero es bueno. El ambar mide
 * disciplina y nada mas (ADR 0003), asi que quien pinta es quien sabe que esta
 * midiendo.
 */

const RADIUS = 60;
const ARC = Math.PI * RADIUS;

export function HalfGauge(props: {
  ratio: number | null;
  caption: string;
  color?: string | undefined;
}): ReactNode {
  /* El vacio no es un cero: si no hay nada revisado, el arco se queda en su
     carril y la cifra dice "—". Un 0 % seria una respuesta que nadie dio. */
  const filled = props.ratio === null ? 0 : Math.min(1, Math.max(0, props.ratio));
  const color = props.color ?? "var(--primary)";

  return (
    <div>
      <div className="gauge">
        <svg viewBox="0 0 150 80" role="img" aria-label={`${props.caption}: ${formatPercent(props.ratio)}`}>
          <path
            d="M15 72 A60 60 0 0 1 135 72"
            fill="none"
            style={{ stroke: "var(--surface-3)" }}
            strokeWidth="12"
            strokeLinecap="round"
          />
          {filled > 0 && (
            <path
              d="M15 72 A60 60 0 0 1 135 72"
              fill="none"
              style={{ stroke: color }}
              strokeWidth="12"
              strokeLinecap="round"
              strokeDasharray={`${(ARC * filled).toFixed(1)} ${ARC.toFixed(1)}`}
            />
          )}
        </svg>
      </div>
      <div className="gauge-val">
        <b className="num">{formatPercent(props.ratio)}</b>
        <small>{props.caption}</small>
      </div>
    </div>
  );
}
